import React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
// views
import { ButtonPresets, ButtonWrapper } from './views'

interface Props {
  preset?: ButtonPresets
  onClick: () => void
  children?: React.ReactNode
  disabled?: boolean
  isActive?: boolean
  description?: string
  'data-testid'?: string
}

const IconButton: React.FC<Props> = ({
  preset = 'DARK_BLUE',
  onClick,
  isActive,
  description,
  disabled,
  children,
  'data-testid': dataTestId
}) => {
  const handleOnClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  const button = (
    <ButtonWrapper
      isActive={isActive}
      disabled={disabled}
      onClick={handleOnClick}
      preset={disabled ? 'DISABLED' : preset}
      data-testid={dataTestId}>
      {children}
    </ButtonWrapper>
  )

  if (description) {
    return <Tooltip title={description}>{button}</Tooltip>
  }

  return button
}

export default IconButton
